import React from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../../hooks/useAuth';

/**
 * Auth-aware handler for the friendly `/intake` URL (registration-gated pivot).
 *
 * The intake form is no longer anonymous — it lives at `/portal/intake` behind
 * auth. `/intake` is kept only as a shareable entry point: authenticated users
 * are sent straight to the portal form; everyone else is sent to registration.
 *
 * There is deliberately NO `/login` route (login is the fallback rendered by
 * `AppLayout` when unauthenticated) and no post-login deep-link mechanism, so an
 * anonymous visitor is routed to `/register` to create the free account the
 * feature now requires.
 */
export const IntakeRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Wait for auth bootstrap so a logged-in user with a still-valid token isn't
  // briefly bounced to /register on a hard refresh.
  if (isLoading) return null;

  return <Navigate to={isAuthenticated ? '/portal/intake' : '/register'} replace />;
};

export default IntakeRedirect;
